export default __webpack_public_path__ + "static/media/stats.997bd4a2.svg";